var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"head"},[_c('div',{staticClass:"wrapper"},[_c('h1',{staticClass:"head-title"},[_vm._v(" Решения для бизнеса ")]),_c('p',{staticClass:"head-subtitle"},[_vm._v(" Проектирование и разработка"),_c('br'),_vm._v(" программного обеспечения для бизнеса ")]),_c('button',{staticClass:"head-btn"},[_vm._v(" Начать проект ")])])])
}]

export { render, staticRenderFns }